/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IsFinancialsManagedExternally/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function IsFinancialsManagedExternally({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/IsFinancialsManagedExternally",
  onChange
  
}) {
let settingsDataIsFinancialsManagedExternallyValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.is_financials_managed_externally',
})
let settingsDataIsFinancialsManagedExternallyChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.is_financials_managed_externally',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 data="settings.data.is_financials_managed_externally"
 value={settingsDataIsFinancialsManagedExternallyValueData}
 onChange={settingsDataIsFinancialsManagedExternallyChangeData}
 marginBottom={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 weight="medium"
 text="Financials handled externally to Greyfinch"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}